/*
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const buffer = document.createElement('div');

export function escapeHTML(string) {
  // @todo: implement a cheaper way to escape HTML characters.
  buffer.textContent = string;
  return buffer.innerHTML;
}

export function isBlobURL(url) {
  return url.startsWith('blob');
}

export * from './DBHelpers';
export { default as getInitialStoryState } from './getInitialStoryState';
export * from './getResourceFromLocalFile';
export * from './isValidFile';
